export const SET_SELECTED = "SET_SELECTED";
export const SET_LOADING = "SET_LOADING";
export const SET_PLACES = "SET_PLACES";

export const setLoadingPlaces = loading => ({
    type: SET_LOADING,
    payload: loading
});

export const setSelectedPlace = place => ({
    type: SET_SELECTED,
    payload: place
});

export const setPlaces = places => ({
    type: SET_PLACES,
    payload: places
});